import client from '../client';

const notificationApi = {
  list: () => client.get('/notifications'),
  markRead: (id) => client.post(`/notifications/${id}/read`),
  markAllRead: () => client.post('/notifications/read-all'),
};

export default notificationApi;
